// extracted by mini-css-extract-plugin
module.exports = {"text":"OpenButton_text__1QVif","contained":"OpenButton_contained__2Xe2H","disabled":"OpenButton_disabled__3TIE3","error":"OpenButton_error__3lnu3"};